module.exports = __webpack_public_path__ + "media/images/posts/post-820bac3333bc789b62226b3b3ab6969a.png";